import React from "react";
import CustomLink from "../../CustomLink";
import { PersonalizeIt } from "../../../Constants";
import { useTranslation } from "react-i18next";

const Tabs = ({ data, activeFormula, onClick, isProductPage = false }) => {
  const { t } = useTranslation();
  return (
    <div className="t-w-full md:t-w-fit t-flex t-items-center t-gap-4 t-overflow-scroll hide-scrollbar">
      {Object.keys(data).map((item) => {
        const name = data[item]?.name;
        return (
          <button
            className={`t-flex-none t-w-fit t-h-[40px] t-px-4 t-rounded-md t-font-extrabold ${
              activeFormula === item
                ? "t-bg-quaternary t-text-white"
                : "t-border-2 t-border-gray-300 t-text-gray-600"
            }`}
            onClick={() => onClick(item)}
          >
            {name}
          </button>
        );
      })}
      {isProductPage && (
        <CustomLink
          to="/quiz"
          className={`t-flex-none t-w-fit t-h-[40px] t-py-2 t-px-4 t-rounded-md t-font-extrabold t-border-2 t-border-gray-300 t-text-gray-600 hover:t-text-gray-600`}
        >
          {t(PersonalizeIt)}
        </CustomLink>
      )}
    </div>
  );
};

export default Tabs;
